<template>
  <div v-if="ncm" class="ncm-container">
    <label>NCM</label>
    <div>{{ ncm }}</div>
  </div>
</template>

<script>
export default {
  name: "RteFrontNcm",

  props: {
    ncm: String
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {}
};
</script>

<style lang="scss" scoped>
.ncm-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  // margin-bottom: 0.3rem;
  label {
    margin-bottom: 0rem;
    font-weight: 600;
    font-size: 1rem;
  }
}
</style>
